// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import GitHubIcon from "@mui/icons-material/GitHub";
import YouTubeIcon from "@mui/icons-material/YouTube";

// Material Kit 2 React components
import MKTypography from "components/MKTypography";

// Images
import logoCT from "assets/images/Logo.png";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "HCC Group ltd",
    image: logoCT,
    route: "/",
  },
  socials: [
    {
      icon: <FacebookIcon />,
      link: "https://www.facebook.com",
    },
    {
      icon: <TwitterIcon />,
      link: "https://twitter.com",
    },
    {
      icon: <GitHubIcon />,
      link: "https://github.com",
    },
    {
      icon: <YouTubeIcon />,
      link: "https://www.youtube.com/",
    },
  ],
  menus: [
    {
      name: "company",
      items: [
        { name: "about us", href: "#" },
        { name: "services", href: "/pages/landing-pages/about-company" },
        { name: "contact us", route: "/pages/landing-pages/contact-us" },
      ],
    },
    {
      name: "Address & Contact",
      items: [
        { name: "39 deere Avenue, ", href: "#" },
        { name: "Rm13 7jd", href: "#" },
        { name: "+44 7470 304459", href: "#" },
        { name: "info@hcc-group.co.uk", href: "#" },
      ],
    },
  ],
  // address: [
  //   {
  //     name: "address",
  //     items: [{ name: "123 Main St, Anytown, USA", href: "#" }],
  //   },
  //   {
  //     name: "phone",
  //     items: [{ name: "123-456-7890", href: "#" }],
  //   },
  //   {
  //     name: "email",
  //     items: [{ name: "info@hccgroup.com", href: "#" }],
  //   },
  // ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      All rights reserved. Copyright &copy; {date} HCC Group ltd.
    </MKTypography>
  ),
};
